"use strict";
// @ts-ignore
try {
    self['workbox:streams:7.2.0'] && _();
}
catch (e) { }
